import React from 'react';
import '../template-file-css/document-file-template.css';


export const EYPC_DmaSiihSra = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EYPC_DmaSiihSra' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3><b>SERVICE AUTHORIZATION FORM</b></h3>
                    <h4><b>INTENSIVE IN-HOME (IIH) H2012 INITIAL</b><br />
                        <b>Service Authorization Request Form</b></h4></center></p>
                <br />

                <p className='w-750'><center><h4><b>MEMBER INFORMATION</b></h4></center></p><br />

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member First Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Last Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberFirstName' name='txtMemberFirstName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberLastName' name='txtMemberLastName' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medicaid #:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Member Date of Birth:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Gender:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtMemberDateOfBirth' name='txtMemberDateOfBirth' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male&nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female&nbsp;
                            <input type='radio' id='rbGender_Other' name='rbGender' className='add-only' value='Other' /> Other</td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Plan ID #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Street Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberPlanId' name='txtMemberPlanId' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberStreetAddress' name='txtMemberStreetAddress' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span></td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity' name='txtCity' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtState' name='txtState' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtZip' name='txtZip' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Guardian:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Guardian Contact Information:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtParentGuardian' name='txtParentGuardian' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtParentGuardianContactInformation' name='txtParentGuardianContactInformation' className='add-only' /></td>

                    </tr>
                </table>
                <br />

                <p className='w-750'><center><h4><b>PROVIDER INFORMATION</b></h4></center></p><br />

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Organization Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Group NPI #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOrganizationName' name='txtOrganizationName' placeholder='Empowering Youth for Positive Change' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtGroupNpi' name='txtGroupNpi' defaultValue={1538446679} className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Tax ID #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Phone:</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderTax' name='txtProviderTax' defaultValue={473114954} className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtProviderPhone' name='txtProviderPhone' defaultValue={8047891314} className='add-only' /></td>

                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider E-Mail:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider Address:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider Fax:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtProviderEmail' name='txtProviderEmail' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtProviderAddress' name='txtProviderAddress' placeholder='101 Cowardin Avenue' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtProviderFax' name='txtProviderFax' placeholder='8044823767' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span></td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity_1' name='txtCity_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtState_1' name='txtState_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtZip_1' name='txtZip_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Clinical Contact Name & Credentials*:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Clinical Contact Phone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClinicalContactName' name='txtClinicalContactName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtClinicalContactPhone' name='txtClinicalContactPhone' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>* This is the individual to whom the MCO can reach out
                    to answer additional clinical questions</b></p>

                <p className='w-750'><span className='eleHeader'>Request for approval of services:</span>
                    From&nbsp;
                    <input type='date' id='txtRequestForApprovalServices_1' name='txtRequestForApprovalServices_1' className='add-only w-150 custom-add-only' /> (date), To&nbsp;
                    &nbsp;<input type='date' id='txtRequestForApprovalServices_2' name='txtRequestForApprovalServices_2' className='add-only w-150 custom-add-only' /> (date), for a total of&nbsp;
                    &nbsp;<input type='text' id='txtRequestForApprovalServices_3' name='txtRequestForApprovalServices_3' className='add-only w-150 custom-add-only' /> units of service.&nbsp;
                    Plan to provide
                    &nbsp;<input type='text' id='txtRequestForApprovalServices_4' name='txtRequestForApprovalServices_4' className='add-only w-150 custom-add-only' /> hours of service per week.
                    <br />

                    <span className='eleHeader'>Retro Review Request?</span>
                    <input type='radio' id='rbRetroReviewRequest_Yes' name='rbRetroReviewRequest' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbRetroReviewRequest_No' name='rbRetroReviewRequest' className='add-only' value='No' /> No
                    <br />

                    <span className='eleHeader'>Is this a new service for the member?</span>
                    <input type='radio' id='rbIsThisNewServiceForTheMember_Yes' name='rbIsThisNewServiceForTheMember' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIsThisNewServiceForTheMember_No' name='rbIsThisNewServiceForTheMember' className='add-only' value='No' /> No
                    <br />

                    <b>(If no, then complete an authorization for continuing care.)</b>
                    <br />

                    <span className='eleHeader'>Primary ICD-10 Diagnosis</span>
                    <input type='text' id='txtPrimaryDiagnosis' name='txtPrimaryDiagnosis' className='add-only' /> <br />

                    <span className='eleHeader'>Secondary Diagnosis(es)</span>
                    <input type='text' id='txtSecondaryDiagnosis' name='txtSecondaryDiagnosis' className='add-only' /> <br />
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name of Medication</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Dosage </span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfMedication_1' name='txtNameOfMedication_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtDosage_1' name='txtDosage_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfMedication_2' name='txtNameOfMedication_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtDosage_2' name='txtDosage_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfMedication_3' name='txtNameOfMedication_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtDosage_3' name='txtDosage_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfMedication_4' name='txtNameOfMedication_4' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtDosage_4' name='txtDosage_4' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>If additional medications are prescribed, include listing of medications, dosage, and frequency in the Notes section.</b>
                    <br /><br />
                    <center><h4><b>SECTION I: INTENSIVE IN HOME ELIGIBILITY CRITERIA</b></h4></center><br />
                    Individuals shall demonstrate medical necessity for the service arising from a condition due to mental,
                    behavioral or emotional illness resulting in significant functional impairments in major life activities <br />

                    <span className='eleHeader'>There is a parent/legal guardian or responsible adult with whom the member is living who is
                        willing to participate in services with the goal of keeping the child with the family</span>
                    <input type='radio' id='rbThereParentLegalGuardianOrResponsible_Yes' name='rbThereParentLegalGuardianOrResponsible' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbThereParentLegalGuardianOrResponsible_No' name='rbThereParentLegalGuardianOrResponsible' className='add-only' value='No' /> No
                    <br />

                    <span className='eleHeader'>The diagnosis must support the mental, behavioral or emotional illness attributed to the
                        recent significant functional impairments in major life activities</span>
                    <input type='radio' id='rbThediagnosisMustSupportTheMental_Yes' name='rbThediagnosisMustSupportTheMental' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbThediagnosisMustSupportTheMental_No' name='rbThediagnosisMustSupportTheMental' className='add-only' value='No' /> No
                    <br /><br />

                    Individual must meet <b>TWO</b> of the following on a continuing or intermittent basis; check applicable criteria: <br />

                    <span className='eleHeader'>Has difficulty in establishing or maintaining normal interpersonal relationships to such a degree
                        that they are at risk of hospitalization or out of home placement because of conflicts with family
                        or community (Note: Please refer to DMAS provider manual for risk of hospitalization and out of
                        home placement definitions/criteria).</span>
                    <input type='radio' id='rbHasDifficultyEstablishingMaintainingNormal_Yes' name='rbHasDifficultyEstablishingMaintainingNormal' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHasDifficultyEstablishingMaintainingNormal_No' name='rbHasDifficultyEstablishingMaintainingNormal' className='add-only' value='No' /> No
                    <br />

                    <b>* If a child is at risk of hospitalization or an out of home placement, state the specific reason
                        and what the out-of-home placement may be.
                    </b><br />

                    <span className='eleHeader'>Describe current symptoms and behaviors or other pertinent information which provides
                        substantiation for <b>CHECKED</b> response (Identify frequency, intensity, and duration of each
                        behavior):</span>
                    <textarea id='txtDescribeCurrentSymptomsBehaviors' name='txtDescribeCurrentSymptomsBehaviors' className='add-only'></textarea> <br />

                    <span className='eleHeader'>Exhibits such inappropriate behavior that documented, repeated interventions by the mental
                        health, social services or judicial system are or have been necessary resulting in being at risk
                        for out of home placement.</span>
                    <input type='radio' id='rbExhibitsSuchInappropriateBehavior_Yes' name='rbExhibitsSuchInappropriateBehavior' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbExhibitsSuchInappropriateBehavior_No' name='rbExhibitsSuchInappropriateBehavior' className='add-only' value='No' /> No
                    <br /><br />

                    Describe current and past services/interventions which provides substantiation for CHECKED
                    response as stated above:</p>

                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>Provider <br />&nbsp;</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>Currently in Service?</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Dates of Services /Interventions</span></td>
                        <td className='w-300'>
                            <span className='eleHeader'>Outcomes/Current Progress<br />&nbsp;
                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtProvider_1' name='txtProvider_1' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentlyInServiceOne_Yes' name='rbCurrentlyInServiceOne' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCurrentlyInServiceOne_No' name='rbCurrentlyInServiceOne' className='add-only' value='No' /> No</td>
                        <td className='w-150'>
                            <input type='date' id='txtDateServicesInterventions_1' name='txtDateServicesInterventions_1' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtOutcomesCurrentProgress_1' name='txtOutcomesCurrentProgress_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtProvider_2' name='txtProvider_2' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentlyInServiceTwo_Yes' name='rbCurrentlyInServiceTwo' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCurrentlyInServiceTwo_No' name='rbCurrentlyInServiceTwo' className='add-only' value='No' /> No</td>
                        <td className='w-150'>
                            <input type='date' id='txtDateServicesInterventions_2' name='txtDateServicesInterventions_2' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtOutcomesCurrentProgress_2' name='txtOutcomesCurrentProgress_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtProvider_3' name='txtProvider_3' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentlyInServiceThree_Yes' name='rbCurrentlyInServiceThree' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCurrentlyInServiceThree_No' name='rbCurrentlyInServiceThree' className='add-only' value='No' /> No</td>
                        <td className='w-150'>
                            <input type='date' id='txtDateServicesInterventions_3' name='txtDateServicesInterventions_3' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtOutcomesCurrentProgress_3' name='txtOutcomesCurrentProgress_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtProvider_4' name='txtProvider_4' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentlyInServiceFour_Yes' name='rbCurrentlyInServiceFour' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCurrentlyInServiceFour_No' name='rbCurrentlyInServiceFour' className='add-only' value='No' /> No</td>
                        <td className='w-150'>
                            <input type='date' id='txtDateServicesInterventions_4' name='txtDateServicesInterventions_4' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtOutcomesCurrentProgress_4' name='txtOutcomesCurrentProgress_4' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Exhibits difficulty in cognitive ability such that they are unable to recognize personal danger or
                        significantly inappropriate social behavior.</span>
                    <input type='radio' id='rbExhibitsDifficultyCognitive_Yes' name='rbExhibitsDifficultyCognitive' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbExhibitsDifficultyCognitive_No' name='rbExhibitsDifficultyCognitive' className='add-only' value='No' /> No <br />

                    <span className='eleHeader'>Describe current symptoms and behaviors or other pertinent information which provides
                        substantiation for CHECKED response (Identify frequency, intensity, and duration of each
                        behavior):
                    </span><textarea id='txtDescribeCurrentSymptomsAndBehaviors' name='txtDescribeCurrentSymptomsAndBehaviors' className='add-only'></textarea>
                </p><br />

                <p className='w-750'><center><h4><b>Individual must meet ONE of the following; check applicable criteria:</b></h4></center>
                    <br />

                    <span className='eleHeader'>Services far more intensive than outpatient clinic care are required to stabilize the individual in
                        the family situation</span>
                    <input type='radio' id='rbServicesFarMoreIntensiveThan_Yes' name='rbServicesFarMoreIntensiveThan' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbServicesFarMoreIntensiveThan_No' name='rbServicesFarMoreIntensiveThan' className='add-only' value='No' /> No <br />

                    <span className='eleHeader'>Describe pertinent information which provides substantiation for CHECKED response (ex. What
                        services have been tried and with what result, Describe severity and intensity of behaviors):
                    </span><textarea id='txtDescribePertinentInformationWhichProvides' name='txtDescribePertinentInformationWhichProvides' className='add-only'></textarea>
                    <br />

                    <span className='eleHeader'>The individual's residence as the setting for services is more likely to be successful than a
                        clinic.
                    </span>
                    <input type='radio' id='rbTheIndividualResidence_Yes' name='rbTheIndividualResidence' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbTheIndividualResidence_No' name='rbTheIndividualResidence' className='add-only' value='No' /> No <br />

                    <span className='eleHeader'>Describe pertinent information which provides substantiation for CHECKED response. If
                        services are going to be performed in alternative service location outside the home setting,
                        please indicate the reason and how interventions will be integrated and generalized into the
                        individual's primary place of residence:
                    </span><textarea id='txtDescribePertinentInformationWhichProvides' name='txtDescribePertinentInformationWhichProvides' className='add-only'></textarea>
                </p> <br /><br />


                <p className='w-750'><center><h4><b>SECTION II: CARE COORDINATION</b></h4></center>
                    <span className='eleHeader'>Primary Care Physician:</span>
                    <input type='text' id='txtPrimaryCarePhysician' name='txtPrimaryCarePhysician' className='add-only' /><br />

                    <span className='eleHeader'>Other medical/behavioral health concerns (including substance abuse issues, developmental/cognitive
                        impairments) that could impact services?
                    </span>
                    <input type='radio' id='rbOtherMedicalBehavioralHealth_Yes' name='rbOtherMedicalBehavioralHealth' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbOtherMedicalBehavioralHealth_No' name='rbOtherMedicalBehavioralHealth' className='add-only' value='No' /> No <br />

                    <b>(If yes, explain below.)</b><br />
                    <textarea id='txtIfYesExplainBelow' name='txtIfYesExplainBelow' className='add-only'></textarea> <br />
                    <b>Please indicate other current medical/behavioral services and additional community supports and
                        interventions being received:</b></p>

                <table>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name of service/treatment</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider/Contact Information</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfServiceTreatment_1' name='txtNameOfServiceTreatment_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtProviderContactInformation_1' name='txtProviderContactInformation_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfServiceTreatment_2' name='txtNameOfServiceTreatment_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtProviderContactInformation_2' name='txtProviderContactInformation_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfServiceTreatment_3' name='txtNameOfServiceTreatment_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtProviderContactInformation_3' name='txtProviderContactInformation_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfServiceTreatment_4' name='txtNameOfServiceTreatment_4' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtProviderContactInformation_4' name='txtProviderContactInformation_4' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Indicate plan to coordinate with primary care physician and other treatment providers/services to help ensure
                                treatment interventions are coordinated:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtIndicatePlanToCoordinateWithPrimary' name='txtIndicatePlanToCoordinateWithPrimary' className='add-only'></textarea>
                        </td>
                    </tr>
                </table><br />

                <p className='w-750'><center><h4><b>SECTION III: TRAUMA-INFORMED CARE</b></h4></center>
                    <b>Trauma-Informed Care</b> (Many individuals have experienced potentially traumatic events in their lifetime. It is important
                    that everyone is aware of the potential impact of trauma on those they serve, prepare to recognize and offer traumaspecific services when needed, and be mindful of trauma-informed interventions.)
                    <br />

                    <span className='eleHeader'>Is there evidence to suggest this member has experienced trauma?
                    </span>
                    <input type='radio' id='rbIsThereEvidenceToSuggestThisMember_Yes' name='rbIsThereEvidenceToSuggestThisMember' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIsThereEvidenceToSuggestThisMember_No' name='rbIsThereEvidenceToSuggestThisMember' className='add-only' value='No' /> No <br />
                    <br />

                    <span className='eleHeader'>What is your plan to assess/refer and address the current and potential effects of that trauma?</span>
                    <textarea id='txtWhatIsYourPlanToAssessReferAnd' name='txtWhatIsYourPlanToAssessReferAnd' className='add-only'></textarea></p>

                <p className='w-750'><center><h4><b>SECTION IV: INDIVIDUAL TREATMENT GOALS</b></h4></center>
                    <b>Treatment Goals/Progress:</b><br />
                <ul>
                    <li>Describe person-centered, recovery-oriented, trauma-informed mental health treatment goals as they relate to
                        requested treatment. Include individual strengths/barriers/gaps in service, and written in own words of individual
                        seeking treatment/or in a manner that is understood by individual seeking treatment. If individual has identified a
                        history of trauma, please include trauma-informed care interventions in the treatment plan.
                    </li>
                    <li>Services are intended to include goal directed training/interventions that will enable individuals to learn the skills
                        necessary to achieve or maintain stability in the least restrictive environment. Providers should demonstrate efforts
                        to assist the individual in progressing toward goals to achieve their maximum potential.</li>
                    <li>Please demonstrate that the individual is benefiting from the service as evidenced by objective progress toward
                        goals or modifications and updates that are being made to the treatment plan to address areas with lack of
                        progress</li>
                    <li>Include any appointments and medications adherence issues and plans to address this, if applicable.</li>
                </ul>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>Resources and Strengths:</b> Document individual's strengths, preferences, extracurricular/community/social activities
                        and people the individual identifies as supports.</span>
                    <textarea id='txtResourcesAndStrengthsDocument' name='txtResourcesAndStrengthsDocument' className='add-only'></textarea>
                    <br />

                    <span className='eleHeader'>Please describe any barriers to treatment:</span>
                    <textarea id='txtPleaseDescribeAnyBarriers' name='txtPleaseDescribeAnyBarriers' className='add-only'></textarea><br />

                    <span className='eleHeader'>How many hours each week will at least one family member be committed to participate in treatment?</span>
                    <input type='text' id='txtHowManyHoursEachWeek' name='txtHowManyHoursEachWeek' className='add-only' /><br />

                    <span className='eleHeader'>How many hours per week of on-site supervision or direct counseling/therapy by an LMHP Type will be
                        provided:</span>
                    <input type='text' id='txtHowManyHoursPerWeekSite' name='txtHowManyHoursPerWeekSite' className='add-only' /><br />

                    <span className='eleHeader'>If no in-home counseling/therapy is provided in the home, why, and who is providing therapy/counseling and
                        what is the frequency?
                    </span>
                    <textarea id='txtIfNoHomeCounselingTherapyProvide' name='txtIfNoHomeCounselingTherapyProvide' className='add-only'></textarea> <br />

                    <span className='eleHeader'>Goal/Objective (Please provide objective measures to demonstrate evidence of progress. Measurable objectives
                        should have meaningful tracking values; avoid percentages unless able to track and measure percent completion i.e. if
                        80%, state 8 of 10 as a more trackable value):</span>
                    <textarea id='txtGoalObjectivePleaseProvide' name='txtGoalObjectivePleaseProvide' className='add-only'></textarea> <br />

                    <span className='eleHeader'>Please describe where the member is now regarding this specific objective.</span>
                    <textarea id='txtPleaseDescribeWhereTheMember' name='txtPleaseDescribeWhereTheMember' className='add-only'></textarea> <br />

                    <span className='eleHeader'>How many days per week will be spent addressing this goal on average?</span>
                    <input type='text' id='txtHowManyDaysPerWeekWill' name='txtHowManyDaysPerWeekWill' className='add-only' /><br />

                    <span className='eleHeader'>What specific counseling and interventions that will be provided to address this goal?</span>
                    <textarea id='txtWhatSpecificCounselingAndInterventions' name='txtWhatSpecificCounselingAndInterventions' className='add-only'></textarea><br />

                    <span className='eleHeader'>How will you measure progress on the counseling or interventions provided? </span>
                    <textarea id='txtHowWillYouMeasureProgressCounseling' name='txtHowWillYouMeasureProgressCounseling' className='add-only'></textarea><br />

                    <span className='eleHeader'><b>Goal/Objective</b>(Please provide objective measures to demonstrate evidence of progress. Measurable objectives
                        should have meaningful tracking values; avoid percentages unless able to track and measure percent completion i.e. if
                        80%, state 8 of 10 as a more trackable value):</span>
                    <textarea id='txtGoalObjectivePleaseProvide' name='txtGoalObjectivePleaseProvide' className='add-only'></textarea><br />

                    <span className='eleHeader'>Please describe where the member is now regarding this specific objective.</span>
                    <textarea id='txtPleaseDescribeMemberSpecific' name='txtPleaseDescribeMemberSpecific' className='add-only'></textarea><br />

                    <span className='eleHeader'>How many days per week will be spent addressing this goal on average?</span>
                    <input type='text' id='txtHowManyDaysGoalAverage' name='txtHowManyDaysGoalAverage' className='add-only' /><br />

                    <span className='eleHeader'>What specific counseling and interventions that will be provided to address this goal?</span>
                    <textarea id='txtWhatSpecificCounselingProvideThisGoal' name='txtWhatSpecificCounselingProvideThisGoal' className='add-only'></textarea><br />

                    <span className='eleHeader'>How will you measure progress on the counseling or interventions provided?</span>
                    <textarea id='txtHowWillMeasureProgressInterventions' name='txtHowWillMeasureProgressInterventions' className='add-only'></textarea><br />

                    <span className='eleHeader'><b>Goal/Objective</b> (Please provide objective measures to demonstrate evidence of progress. Measurable objectives
                        should have meaningful tracking values; avoid percentages unless able to track and measure percent completion i.e. if
                        80%, state 8 of 10 as a more trackable value):</span>
                    <textarea id='txtGoalPleaseProvideObjective' name='txtGoalPleaseProvideObjective' className='add-only'></textarea><br />

                    <span className='eleHeader'>Please describe where the member is now regarding this specific objective.</span>
                    <textarea id='txtPleaseMemberRegardingSpecificObjective' name='txtPleaseMemberRegardingSpecificObjective' className='add-only'></textarea><br />

                    <span className='eleHeader'>How many days per week will be spent addressing this goal on average?</span>
                    <input type='text' id='txtManyDaysPerWeekAverage' name='txtManyDaysPerWeekAverage' className='add-only' /><br />

                    <span className='eleHeader'>What specific counseling and interventions that will be provided to address this goal?</span>
                    <textarea id='txtSpecificCounselingInterventions' name='txtSpecificCounselingInterventions' className='add-only'></textarea><br />

                    <span className='eleHeader'>How will you measure progress on the counseling or interventions provided?</span>
                    <textarea id='txtMeasureProgressCounselingInterventions' name='txtMeasureProgressCounselingInterventions' className='add-only'></textarea><br />
                </p>

                <p className='w-750'>
                    <center><h4><b>SECTION V: DISCHARGE PLANNING</b></h4></center>
                    <b>DISCHARGE PLAN </b>(Identify lower levels of care, natural supports, warm-hand off, care coordination needs)</p>

                <table>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Step Down Service/Supports</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Identified Provider/Supports</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Plan to assist in transition</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtStepDownServiceSupports_1' name='txtStepDownServiceSupports_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtIdentifiedProviderSupports_1' name='txtIdentifiedProviderSupports_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtPlanToAssistTransition_1' name='txtPlanToAssistTransition_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtStepDownServiceSupports_2' name='txtStepDownServiceSupports_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtIdentifiedProviderSupports_2' name='txtIdentifiedProviderSupports_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtPlanToAssistTransition_2' name='txtPlanToAssistTransition_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtStepDownServiceSupports_3' name='txtStepDownServiceSupports_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtIdentifiedProviderSupports_3' name='txtIdentifiedProviderSupports_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtPlanToAssistTransition_3' name='txtPlanToAssistTransition_3' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Recommended level of care at discharge</span>
                    <textarea id='txtRecommendedLevelDischarge' name='txtRecommendedLevelDischarge' className='add-only'></textarea><br />

                    Estimated date of discharge:&nbsp;
                    <input type='date' id='txtEstimateDateDischarge' name='txtEstimateDateDischarge' className='add-only w-200 custom-add-only' /> <br />

                    The appropriate assessment or addendum has been completed by an LMHP, LMHP-R, LMHP-S, or LMHP RP and the
                    individual's psychiatric history information reviewed. By my signature (below) I am attesting that the individual meets
                    the medical necessity criteria for the identified service. The assessment or applicable addendum for this service was
                    completed on&nbsp;
                    <input type='date' id='txtTheAppropriateAssessmentAddendum' name='txtTheAppropriateAssessmentAddendum' className='add-only w-200 custom-add-only' />
                </p>

                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'>Signature (actual or electronic) of LMHP (Or R/S/RP</td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <span className='eleHeader'>Printed Name of LMHP (Or R/S/RP)</span></td>
                        <td className='w-300'>
                            <span className='eleHeader'>Credentials:</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='text' id='txtPrintedName' name='txtPrintedName' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtCredentials' name='txtCredentials' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If any additional CMHRS services were recommended by the assessment or addendum referenced above, please identify
                                the services here:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtIfAnyAdditionalServicesWereRecommended' name='txtIfAnyAdditionalServicesWereRecommended' className='add-only'></textarea>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><center><h4><b>NOTES SECTION</b></h4></center>
                    <span className='eleHeader'>If needed, use this page for any answer too long to fit within the form's provided spaces. Please note which
                        section you are continuing before each answer.</span>
                    <textarea id='txtNotesSections' name='txtNotesSections' className='add-only'></textarea></p>






























            </div >
        </form >

    )
}











